import { useQuery } from "@tanstack/react-query";
import { getQuizSubmissionDetails } from "../../../api/endpoints/QuizEndpoints";

export default function useGetQuizSubmissionDetails(
  quizId: number,
  submissionId?: number,
) {
  return useQuery({
    queryKey: ["quiz-submission", quizId, submissionId],
    queryFn: () => getQuizSubmissionDetails(quizId, submissionId!),
    enabled: !!submissionId,
  });
}
